import { render } from "./diabetes_procedures.vue?vue&type=template&id=1060414e&scoped=true"
import script from "./diabetes_procedures.vue?vue&type=script&lang=js"
export * from "./diabetes_procedures.vue?vue&type=script&lang=js"

import "./diabetes_procedures.vue?vue&type=style&index=0&id=1060414e&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1060414e"]])

export default __exports__